import { Avatar, AvatarGroup } from "@chakra-ui/react"
import UserAvatar, { UserAvatarProps } from "./UserAvatar"
import { AvatarUser } from "./types"

type UserAvatarStackOwnProps = {
  user?: AvatarUser // Main user to display first (optional).
  users: AvatarUser[] // Other users to display after the main user.
  // Used to calculate excess avatars in edge cases (e.g. server total exceeds loaded users).
  total?: number
  max?: number
}

type UserAvatarStackProps = UserAvatarStackOwnProps &
  Omit<UserAvatarProps, "user">

// Dumb component that accepts the group.
export const UserAvatarStack = ({
  user,
  users,
  total,
  max = 3,
  children,
  preferIcon,
  icon,
  fallback,
  srcSet,
  ...avatarRootProps
}: UserAvatarStackProps) => {
  const sortedUsers: AvatarUser[] = []

  // Push the user's user, if provided, into the first position.
  if (user) sortedUsers.push(user)
  // Push all other users after, filtering out the user's user if found in the list.
  sortedUsers.push(
    ...(users.filter((user) => user.id !== sortedUsers[0]?.id) || [])
  )

  if (sortedUsers.length === 0) return null

  const visibleUsers = sortedUsers.slice(0, max)
  const effectiveTotal = total ?? sortedUsers.length
  const hiddenCount = Math.max(0, effectiveTotal - visibleUsers.length)

  return (
    <AvatarGroup size="xs" gap={-1}>
      {visibleUsers.map((user) => (
        <UserAvatar
          key={user.id}
          user={user}
          color="white"
          borderBottomWidth={0}
          preferIcon={preferIcon}
          icon={icon}
          fallback={fallback}
          srcSet={srcSet}
          {...avatarRootProps}
        >
          {children}
        </UserAvatar>
      ))}
      {hiddenCount > 0 && (
        <Avatar.Root
          size="xs"
          // color="white"
          border="none"
          {...avatarRootProps}
        >
          <Avatar.Fallback>+{hiddenCount}</Avatar.Fallback>
        </Avatar.Root>
      )}
    </AvatarGroup>
  )
}

export default UserAvatarStack
